import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ProblemSolution() {
  const comparisons = [{
    problem: 'Tu web está desactualizada o directamente no tienes una',
    solution: 'Web + carta digital + redes sociales trabajando juntos',
    metric: '+95% Eficiencia'
  }, {
    problem: 'Pierdes clientes porque no te encuentran o no confían en lo que ven',
    solution: 'Diseño pensado para que cada visita se convierta en cliente',
    metric: '+120% Conversión'
  }, {
    problem: 'No sabes cuántos clientes llegan gracias a tu presencia online',
    solution: 'Una base digital que crece contigo sin límites',
    metric: 'ROI Medible'
  }, {
    problem: 'Tu imagen digital no refleja la calidad real de tu negocio',
    solution: 'Imagen profesional que genera confianza al instante',
    metric: 'Top 1% Sector'
  }];
  return <section className="py-24 bg-[#0a0a0a] relative border-t border-white/[0.05]" data-id="element-163">
      <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-164">
        <div className="text-center md:text-left mb-16" data-id="element-165">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-166">
            <h2 className="text-3xl md:text-4xl font-medium text-white mb-4 tracking-tight" data-id="element-167">
              De la irrelevancia digital al liderazgo en tu sector
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl" data-id="element-168">
              Las empresas estancadas operan con herramientas aisladas. Los
              líderes del mercado dominan a través de ecosistemas digitales
              integrados.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="card-premium !overflow-hidden" data-id="element-169">
          {/* Header Row (Desktop) */}
          <div className="hidden md:grid grid-cols-2 border-b border-white/[0.05] bg-white/[0.02]" data-id="element-170">
            <div className="p-6 text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-171">
              El problema actual
            </div>
            <div className="p-6 text-sm font-medium text-white uppercase tracking-wider border-l border-white/[0.05]" data-id="element-172">
              El ecosistema Growthly
            </div>
          </div>

          {/* Comparison Rows */}
          <div className="divide-y divide-white/[0.05]" data-id="element-173">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-[#131313] transition-colors" data-id="element-174">
                {/* Problem */}
                <div className="p-6 md:p-8 flex items-start gap-4" data-id="element-175">
                  <div className="mt-0.5 shrink-0" data-id="element-176">
                    <X size={18} className="text-gray-600" data-id="element-177" />
                  </div>
                  <p className="text-gray-400 text-[15px] leading-relaxed" data-id="element-178">
                    {item.problem}
                  </p>
                </div>

                {/* Solution */}
                <div className="p-6 md:p-8 flex items-start gap-4 border-t md:border-t-0 md:border-l border-white/[0.05] bg-white/[0.015] md:bg-transparent md:group-hover:bg-white/[0.02] transition-colors relative" data-id="element-179">
                  <div className="mt-0.5 shrink-0" data-id="element-180">
                    <Check size={18} className="text-brand-emerald" data-id="element-181" />
                  </div>
                  <div className="flex-1" data-id="element-182">
                    <p className="text-gray-200 text-[15px] leading-relaxed mb-3" data-id="element-183">
                      {item.solution}
                    </p>
                    <span className="badge-premium !text-[11px] !uppercase !tracking-wider" data-id="element-184">
                      {item.metric}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}